import * as THREE from "three";

/**
 * One principal shadow-casting light plus a soft hemisphere fill — the
 * "single shadow-casting light" ceiling from section 23.
 */
export class Lighting {
  readonly key: THREE.DirectionalLight;
  readonly fill: THREE.HemisphereLight;

  constructor(scene: THREE.Scene, shadowMapSize: number) {
    this.fill = new THREE.HemisphereLight(0x8fa4ff, 0x14121a, 0.55);
    scene.add(this.fill);

    this.key = new THREE.DirectionalLight(0xfff2de, 1.4);
    this.key.position.set(5, 8, 4);
    this.key.castShadow = true;
    this.key.shadow.mapSize.set(shadowMapSize, shadowMapSize);
    this.key.shadow.camera.near = 1;
    this.key.shadow.camera.far = 30;
    this.key.shadow.camera.left = -8;
    this.key.shadow.camera.right = 8;
    this.key.shadow.camera.top = 8;
    this.key.shadow.camera.bottom = -8;
    this.key.shadow.bias = -0.0015;
    scene.add(this.key);
    scene.add(this.key.target);
  }

  /** Regenerates the shadow map at a new resolution (e.g. toggling reduced mode). */
  setShadowMapSize(size: number): void {
    this.key.shadow.mapSize.set(size, size);
    this.key.shadow.map?.dispose();
    this.key.shadow.map = null;
  }

  dispose(scene: THREE.Scene): void {
    scene.remove(this.fill, this.key, this.key.target);
    this.key.shadow.map?.dispose();
  }
}
